import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/tokens.css";
import App from "./App";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "[YOGO] Root element #root not found. Check apps/client/index.html.",
  );
}

createRoot(rootElement).render(<App />);

// Day 29 complete
